import { useState, useEffect } from 'react';
import { portalApi } from '../../api';

const STATUS: Record<string, { label: string; color: string }> = {
  pending: { label: '待接单', color: 'bg-yellow-100 text-yellow-700' },
  accepted: { label: '业务员已接', color: 'bg-blue-100 text-blue-700' },
  approved: { label: '后勤审核通过', color: 'bg-indigo-100 text-indigo-700' },
  invoiced: { label: '已开票', color: 'bg-purple-100 text-purple-700' },
  shipped: { label: '已发货', color: 'bg-teal-100 text-teal-700' },
  completed: { label: '已完成', color: 'bg-green-100 text-green-700' },
  cancelled: { label: '已取消', color: 'bg-red-100 text-red-700' },
};

export default function PortalOrders() {
  const [orders, setOrders] = useState<any[]>([]);
  const [open, setOpen] = useState<number | null>(null);

  const load = () => portalApi('/orders').then(setOrders).catch(() => {});
  useEffect(load, []);

  return (
    <div className="space-y-3">
      <h2 className="text-lg font-bold text-emerald-800">📦 我的报货单</h2>
      {orders.map((o) => (
        <div key={o.id} className="bg-white rounded-xl shadow-sm p-3 border border-slate-100">
          <div className="flex items-center justify-between">
            <div>
              <div className="font-mono text-sm">{o.order_no}</div>
              <div className="text-xs text-slate-400">{(o.created_at || '').slice(0, 19).replace('T', ' ')}</div>
            </div>
            <div className="text-right">
              <span className={`text-xs px-2 py-1 rounded-full ${STATUS[o.status]?.color || 'bg-gray-100'}`}>{STATUS[o.status]?.label || o.status}</span>
              <div className="text-emerald-600 font-bold mt-1">¥{Number(o.total_amount || 0).toLocaleString()}</div>
            </div>
          </div>
          <button onClick={() => setOpen(open === o.id ? null : o.id)} className="text-xs text-emerald-600 mt-2 hover:underline">
            {open === o.id ? '收起明细' : '查看明细'}
          </button>
          {open === o.id && (
            <div className="mt-2 divide-y text-sm">
              {(o.items || []).map((it: any, i: number) => (
                <div key={i} className="flex justify-between py-1">
                  <span>{it.product_name} × {it.quantity}</span>
                  <span className="text-slate-500">¥{Number(it.amount || 0).toLocaleString()}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
      {orders.length === 0 && <div className="text-slate-400 text-sm">暂无报货单，去首页挑选产品吧</div>}
    </div>
  );
}
